import { initializeApp } from '@firebase/app'
import { getFirestore, collection } from '@firebase/firestore'
import { firebaseConfig } from '@configs/firebaseConfig'

const firebase = initializeApp(firebaseConfig)
const db = getFirestore()
const mailCollection = collection(db, 'mail')

export { firebase, mailCollection }
